"use client";

import React from "react";
import SectionHeading from "./section-heading";
import Project from "./project";
import { useSectionInView } from "@/lib/hooks";
import { useI18nContext } from "@/context/i18n-context";
import en from "@/locale/en";

type ProjectProps = (typeof en.projects.data)[number];

export default function Projects() {
  const { t } = useI18nContext();
  const links: { name: string; hash: string }[] = t("links");
  const { ref } = useSectionInView(links[2]?.name ?? "Projects", 0.5);

  return (
    <section ref={ref} id="projects" className="w-full max-w-[52rem] scroll-mt-28 mb-24 sm:mb-32">
      <SectionHeading>{t("projects.title")}</SectionHeading>
      <div className="flex flex-col gap-5">
        {t("projects.data").map((project: ProjectProps, index: number) => (
          <Project key={index} {...project} index={index} />
        ))}
      </div>
    </section>
  );
}
